export default __webpack_public_path__ + "static/media/frame20x30-black.add82548.jpg";